import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { Controller } from '../../Controller';
import { Person } from '../../../../../common/js/customer/Person';
import { ApplicationTypes } from '../../../../../coverpath-common/js/interfaces/CoverpathTypes';

@Component({
  moduleId: module.id,
  selector: 'concurrentmodification',
  templateUrl: './concurrentmodification.component.html',
})
export class ConcurrentModificationComponent {
  headerText: string;
  controller: Controller;

  constructor(private amorphicService: AmorphicService, private router: Router) {
    this.controller = amorphicService.controller as Controller;
    const applicationType: string = router.getCurrentNavigation().extractedUrl.queryParams.type;
    switch (applicationType) {
      case ApplicationTypes.DELETED: {
        this.headerText = `The application you're looking for was deleted by your financial professional`;
        break;
      }
      case ApplicationTypes.PRIOR: {
        this.headerText = `The application you're looking for is being edited by your financial professional`;
        break;
      }
      default: {
        this.headerText = `The application you're looking for is not available`;
      }
    }
  }

  emailAdvisor(): void {
    window.open(`mailto:${this.primaryAgentEmail}`);
  }

  routeTo(route: string): void {
    this.router.navigate([route]);
  }

  private get primaryAgentEmail(): string {
    let agentProfile: Person;
    try {
      agentProfile = this.controller.customer.application.primaryPolicy.primaryPolicyAgent.primaryAgent.person;
    } catch (error) {
      this.amorphicService.amorphicLogError(
        'ConcurrentModificationComponent',
        'primaryAgentEmail',
        `Error getting primary agent info for application ${this.controller.customer.application.applicationNumber}. Application being accessed was taken back by financial professional to edit or was deleted`,
        error
      );
      return undefined;
    }

    return agentProfile.email;
  }
}
